import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import GitHubCalendar from 'react-github-calendar';
import ReactTooltip from 'react-tooltip';

function Github() {
  const selectLastHalfYear = (contributions) => {
    const currentYear = new Date().getFullYear();
    const currentMonth = new Date().getMonth();
    const shownMonths = 6;

    return contributions.filter((day) => {
      const date = new Date(day.date);
      const monthOfDay = date.getMonth();

      return (
        date.getFullYear() === currentYear &&
        monthOfDay > currentMonth - shownMonths &&
        monthOfDay <= currentMonth
      );
    });
  };

  return (
    <Box margin="auto" marginTop="100px" width="80%">
      <Box>
        <Text as="b" fontSize={["24px", "32px", "32px", "42px"]} textDecoration="underline">
          GitHub Activity
        </Text>
      </Box>
      <Box marginTop="50px">
        <GitHubCalendar
          style={{ margin: 'auto' }}
          responsive={true}
          tooltips={true}
          theme={{
            background: 'transparent',
            text: '#333',
            grade4: 'rgba(0, 70, 170, 0.5)',
            grade3: 'rgba(0, 70, 170, 0.7)',
            grade2: 'rgba(0, 70, 170, 0.8)',
            grade1: 'rgba(0, 70, 170, 0.9)',
            grade0: 'rgba(0, 70, 170, 1)',
          }}
          width="100%"
          username="Rohit20033"
          transformData={selectLastHalfYear}
          blockSize={15}
          fontSize={16}
        >
          <ReactTooltip delayShow={20} html />
        </GitHubCalendar>
      </Box>
    </Box>
  );
}

export default Github;
